import * as React from "react";
import * as models from "app/models/requireme";
import * as resources from "app/resources/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";

import { PartidaAclaracionForm } from "./form";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

const PartidaAclaracionFormRx = componentToRx(PartidaAclaracionForm);
type Entity = models.PartidaAclaracion;
const resource = resources.PartidasAclaracion;

interface Props {
    match: match<{ id: string }>
}
interface State {
    value: Promise<Entity> | Entity;
}
class PartidaAclaracionEditComp extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { value: this.getValue() };
    }
    get id(): number | "new" {
        const id = this.props.match.params.id;
        return id == "new" ? id : Number.parseInt(id);
    }
    async getValue() {
        if (this.id == "new") {
            return {} as Entity;
        } else {
            return await resource.get(this.id);
        }
    }

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: {...value, } as Entity }, resolve));

    onGuardar = async () => {
        const id = this.id;
        const func = id == "new" ? resource.add : resource.update;
        const value = await this.state.value;
        await func(value);
        history.go("/operativa/partidasaclaracion");
    }

    render() {
        const props = this.props;
        const params = props.match!.params.id;
        return <PartidaAclaracionFormRx
            value={this.state.value}
            onChange={this.onChange}
            nuevo={this.id == "new"}
            permisos={resources.User.PermisoRx}
            onGuardar={this.onGuardar} />;
    }
}

export const PartidaAclaracionEdit = withRouter(PartidaAclaracionEditComp);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/partidasaclaracion/edit/edit.tsx